interface AccessibleSortMsgType {
  sortOrder: string | undefined;
}
export const AccessibleSortMsg = ({ sortOrder }: AccessibleSortMsgType) => {
  let msg = "";
  let actionMsg = "";
  switch (sortOrder) {
    case undefined:
      msg = "Unsorted.";
      actionMsg = `Click to sort by ascending order.`;
      break;
    case "ascend":
      msg = "Sorted by ascending order.";
      actionMsg = `Click to sort by descending order.`;
      break;
    case "descend":
      msg = "Sorted by descending order.";
      actionMsg = `Click to clear sort.`;
      break;
  }
  return (
    <span className="sr-only">
      {msg} {actionMsg}
    </span>
  );
};
